import { GENERIC_STATUS, hasContactManageAccess } from "../../../utils/constants";

export const getUpdatedFieldData = (data) => {
    const firstNames = [];
    const lastNames = [];
    const phoneNumbers = [];
    const countryCode = [];
    const others = [];

    for (const item of data) { 
        const fieldName = item.contact_field_name.toLowerCase(); 
        switch(fieldName){
            case "first name": 
                firstNames.push(item);
                break;
            case "last name": 
                lastNames.push(item);
                break;
            case "phone number": 
                phoneNumbers.push(item);
                break;
            case "country_code": 
            case "country code":
                countryCode.push(item);
                break;
            default: 
                others.push(item);
                break; 
        }
    }
    
    return [...firstNames, ...lastNames, ...countryCode, ...phoneNumbers, ...others];
}

export const phoneNumberRegEx = /^(\+)?[0-9]*$/; 

export const requiredFields = ["first name", "phone number", "country code"];

export const isRequiredContactField = (fieldName) => {
    return requiredFields.includes(fieldName?.toLowerCase() ?? '');
}

export const isDefaultContactField = (field) => {
    return Boolean(field?.flag_default);
}

export const SAMPLE_CONTACT_CSV_DOCUMENT = 'https://docs.google.com/spreadsheets/d/14LTchOHCv31cr-sFswsM3KrTUTAeRRg9py7eAF2YDjI/export?format=csv';

export const getCustomTagOption = (apiRoutesPermissionAssignment, userDetail) => {
    const hasPermissionToAddTag = hasContactManageAccess(apiRoutesPermissionAssignment, userDetail);
    let customTagOption = [];
    
    if(hasPermissionToAddTag){
        customTagOption = [{
            contact_tag_name: "New Tag",
            contact_tag_id: -1,
            created_at_timestamp: "",
            updated_at_timestamp: "",
        }]
    }

    return customTagOption;
}

export const OPT_OUT_META_TAG_NAME = "Opt-out Meta";

export const isOptOutMetaTag = (tagName) => {
    return tagName?.toLowerCase() === OPT_OUT_META_TAG_NAME?.toLowerCase();
}

export const isGenericTag = (contactListId) => {
    return contactListId === null;
}

export const isMasterContactList = (contactListName) => {
    return contactListName?.trim()?.toLowerCase() === "master contact list";
}

// The master contact list never allows duplicate contacts
export const isDuplicateContactAllowed = (list) => {
    return list?.flag_allow_duplicate_contact === true && !isMasterContactList(list?.contact_list_name);
}

export const DUPLICATE_CONTACT_TEXT = {
    ALLOW_LABEL: "Allow Duplicate Contacts",
    DISALLOW_LABEL: "Disallow Duplicate Contacts",
    ALLOW_BUTTON: "Allow",
    DISALLOW_BUTTON: "Disallow",
    ALLOW_NOTE: "Contacts with the same phone number can then be added to this list, through import or one at a time.",
    DISALLOW_NOTE: "New contacts whose phone number is already in this list will be skipped. This can't be turned off while the list still has contacts with the same phone number.",
    ALLOW_SUCCESS: "Duplicate contacts are now allowed in this list",
    DISALLOW_SUCCESS: "Duplicate contacts are no longer allowed in this list",
    IMPORT_NONE: "No contacts were imported. Check that each row has a valid phone number and a first name.",
}

export const getDuplicateContactConfirmationDescription = (list) => {
    const action = isDuplicateContactAllowed(list) ? "disallow" : "allow";
    return `Are you sure you want to ${action} duplicate contacts in "${list?.contact_list_name}" list`;
}

export const getArchiveContactListStatusId = (globalStatusData) => {
    return globalStatusData?.find((status) => status.status_name?.toLowerCase() === GENERIC_STATUS.ARCHIVED?.toLowerCase())?.status_id;
}

export const isArchivedContactList = (list, globalStatusData) => {
    const archivedStatusId = getArchiveContactListStatusId(globalStatusData);
    const isArchivedByStatusId = archivedStatusId != null && list?.contact_list_status_id === archivedStatusId;
    const isArchivedByStatusName = list?.contact_list_status_name?.toLowerCase() === GENERIC_STATUS.ARCHIVED?.toLowerCase();
    return isArchivedByStatusId || isArchivedByStatusName;
}

export const filterOutArchivedContactLists = (lists) => {
    return lists?.filter((list) => list?.contact_list_status_name?.toLowerCase() !== GENERIC_STATUS.ARCHIVED?.toLowerCase()) ?? [];
}
